import LegoData from './lego.json';
export const Lego = LegoData;

const lottieAssets = {
  Lego: LegoData
};